// extracted by mini-css-extract-plugin
module.exports = {"container":"Assets_container__383YZ","heading":"Assets_heading__12Q5v","subHeading":"Assets_subHeading__1YuOc"};